export default class RenderService {
  constructor(
    $document, $interval, $state, $timeout, $uibModal, $window, $location, $sce,
    ActionService, AuthService, DomService, EventService, featureAccess,
    FEService, FlashService, RecordService, SchemaService, GeoLocationService,
    ScriptLoaderService, TBService, TemplateService, TokenRefreshService, QueryParamService) {

    'ngInject';

    Object.assign(this, { 
      $document, $interval, $state, $timeout, $uibModal, $window, $location, $sce,
      ActionService, AuthService, DomService, EventService, featureAccess, 
      FEService, FlashService, RecordService, SchemaService, GeoLocationService,
      ScriptLoaderService, TBService, TemplateService, TokenRefreshService, QueryParamService
    });
  }
  
  referenceFieldId(token) {
    return token ? `ref-${token.referenceId}-fid-${token.fieldId}` : '';
  }

  iosClassTag() {
    if(/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      // used to apply i(Pad)OS-specific CSS etc
      $('body').addClass('ios-device');
    }
  }
  
  b64toBlob(b64Data, contentType, sliceSize=512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType || ''});
  }

}
